/**
 *
 * Styles for PresetCard
 *
 */

import styled, { css } from "styled-components";
import { Icon, Card } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

const cardSize = css`
  width: calc(50% - 0.4rem);
  height: auto;
  margin-bottom: var(--dui-size-space-5x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: auto;

    min-width: ${(props) =>
      props.appearance === "small" ? "17.9rem" : "20.5rem"};
    height: 7.5rem;
    margin-bottom: 0;
  }
`;

export const StyledCard = styled(Card)`
  position: relative;
  display: inline-block;
  padding: 0;
  box-shadow: rgb(229, 229, 229) 0px 3px 8px 0px;
  border: solid var(--dui-size-width-border-xs) var(--dui-color-gray-200);
  background-color: var(--dui-color-white-500);

  &:nth-child(odd) {
    margin-right: 0.7rem;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-top: var(--dui-size-space-5x);

    &:not(:last-of-type) {
      margin-right: 1.2rem;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

  ${cardSize}
`;

export const ButtonItself = styled.button`
  background-color: transparent;
  border: var(--dui-size-width-border-sm) solid transparent;
  border-radius: var(--dui-size-radius-md);
  transition: box-shadow 0.3s ease-out;
  line-height: var(--dui-size-line-height-lg);
  text-align: center;
  text-decoration: none;
  color: var(--dui-color-black-500);
  min-height: 110px;
  width: 100%;
  position: relative;
  font-weight: 700;
  padding: 0;
  font-size: var(--dui-size-font-sm);
  flex-direction: column;
  display: flex;
  align-items: center;
  min-width: inherit;

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    height: 7.5rem;
    min-height: 7.5rem;
    font-size: var(--dui-size-font-md);
  }

  &:hover,
  &:focus,
  &:focus-within,
  &:active {
    box-shadow: rgb(178, 178, 178) 0px 2px 7px 1px;
    outline: 0;
  }

  &.selected {
    border-color: var(--dui-color-red-500);
    transition: opacity 0.3s ease-out;
  }

  &:not(.selected):hover {
    border-color: transparent;
  }

  &.selected + .toggleIcon {
    opacity: 1;
  }

  @media screen and (max-width: ${breakpoints.tablet}) {
    .content-icon {
      margin-bottom: var(--dui-size-space-9x);

      &:not(.presetXS) {
        transform: translateX(-5%) translateY(29%);
      }
    }

    .presetXS svg {
      height: 45px;
      transform: translateY(15%);
      margin-top: var(--gaq-size-space-5px);
    }
  }

  .content-icon {
    width: auto;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-left: var(--gaq-size-space--2px);
      margin-bottom: var(--dui-size-space-5x);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin-bottom: 0;
    }

    /* Fix: Pallet icons are glued to the right, this is a problem in RTL where we don't flip the icons */
    &.palletEurOne,
    &.palletEurThree,
    &.nlPaletEur1,
    &.nlPaletEur3,
    &.auStandardPallet,
    &.auExportPallet,
    &.us1Pallet,
    &.mxStandardPallet,
    &.eur1Pallet,
    &.eur3Pallet,
    &.cp3Pallet {
      /*! @noflip */
      margin-right: var(--gaq-size-space-3px) !important;
    }
  }
`;

export const CardContent = styled.div`
  z-index: ${(props) => (props.cssZIndex ? props.cssZIndex : "0")};
  top: 0;
  box-sizing: content-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  border-radius: var(--dui-size-radius-md);
  width: 100%;
  justify-content: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    position: absolute;
    justify-content: flex-start;
    flex-wrap: inherit;
    min-width: 100%;
    height: 100%;
    min-height: auto;
    padding: 0;
  }
`;

export const BoxWrapper = styled.div`
  display: block;
  width: 100%;
  text-align: left;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: var(--dui-size-space-2x);
    width: auto;
  }
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    margin: 0;
    max-width: inherit;
    display: block;
    text-align: center;

    @media screen and (min-width: ${breakpoints.tablet}) {
      max-width: 12.9rem;
      text-align: inherit;
    }
  }
`;

export const StyledTextSizes = styled(DhlText)`
  & > *:is(p, span) {
    display: block;
    text-align: center;
    /*! @noflip */
    direction: ltr;

    @media screen and (min-width: ${breakpoints.tablet}) {
      text-align: inherit;
    }
  }
`;

export const StyledIconWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-right: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-top: 15px solid var(--dui-color-red-500);
  border-left: 15px solid var(--dui-color-red-500);
  border-radius: var(--dui-size-radius-md);
  opacity: 0;
  transition: opacity 0.3s ease-out;
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  top: -12px;
  left: -11px;
  display: block;
`;
